import logoLight from "@/assets/brand/studio/logo-color-hz-black.svg";
import logoDark from "@/assets/brand/studio/logo-color-hz-white.svg";
import markLight from "@/assets/brand/studio/mark-black.svg";
import markDark from "@/assets/brand/studio/mark-white.svg";
import openGraph from "@/assets/brand/studio/open-graph.png";
import { AppEnvironment } from "..";
import { Brand } from "./types";

export const studioBrand: Brand = {
  id: "studio",
  name: "MakeMusic Studio",
  shortName: "Studio",
  legalName: "MakeMusic, Inc.",
  logos: {
    logo: {
      dark: logoDark,
      light: logoLight,
    },
    mark: {
      dark: markDark,
      light: markLight,
    },
    openGraph,
  },
  helpUrl: "https://help.studio.makemusic.com",
  supportEmail: "support@makemusic.app",

  pageTitle: (title: string) => `MakeMusic Studio | ${title}`,

  urls: (environment: AppEnvironment) => {
    switch (environment) {
      case "development":
        return {
          app: "https://studio.local.makemusic.app",
          // api: "https://api.studio.local.makemusic.app:3002",
          api: "https://api.studio.uat.makemusic.app",
          cdn: "https://cdn.studio.uat.makemusic.app",
          reports: "https://api.studio.uat.makemusic.app",
          web: "https://studio.uat.makemusic.com",
        };
      case "preview":
        return {
          app: "https://studio.uat.makemusic.app",
          api: "https://api.studio.uat.makemusic.app",
          cdn: "https://cdn.studio.uat.makemusic.app",
          reports: "https://api.studio.uat.makemusic.app",
          web: "https://studio.uat.makemusic.com",
        };
      case "production":
        return {
          app: "https://studio.makemusic.app",
          api: "https://api.studio.makemusic.app",
          cdn: "https://cdn.studio.makemusic.app",
          reports: "https://reports.studio.makemusic.app",
          web: "https://studio.makemusic.com",
        };
    }
  },
};
